import './App.scss';

import { ConfigProvider } from 'antd';

import {
    AuthProvider,
    ErrorAllProvider,
    ErrorProvider,
    MessageProvider,
    ModalProvider,
    useLanguage,
    useTheme,
} from '@/v1/main/views/Provider';
import { Router } from '@/v1/main/views/Router';

export const App = () => {
    const { algorithm } = useTheme();
    const { locale } = useLanguage();
    return (
        <ConfigProvider locale={locale} theme={{ algorithm }}>
            <MessageProvider>
                <ModalProvider>
                    <ErrorAllProvider>
                        <ErrorProvider>
                            <AuthProvider>
                                <Router />
                            </AuthProvider>
                        </ErrorProvider>
                    </ErrorAllProvider>
                </ModalProvider>
            </MessageProvider>
        </ConfigProvider>
    );
};
